import React from 'react';
import AdminYoutubeApi from '../../components/admin/AdminYoutubeApi';

const AdminYoutubeApiPage = () => {
  return <AdminYoutubeApi />;
};

export default AdminYoutubeApiPage;
